import React from "react";
import { useIntl } from "react-intl";
import { Info as InfoIcon } from "@piiqtechnologies/svg-icons";
import { PeekBox, PeekStack, PeekTab, PeekTabs, PeekTooltip, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import messages from "../messages.i18n";
export const CustomSubtopicsHeader = ({ tabs, activeTabId, activeTabIndex, customSubtopicsCount, maxCustomSubtopics, onTabChange, }) => {
    const intl = useIntl();
    const theme = useTheme();
    const isLimitReached = customSubtopicsCount >= maxCustomSubtopics;
    return (React.createElement(PeekStack, { direction: "row", alignItems: "center", justifyContent: "space-between", mx: 1.5, mt: 1.5, sx: {
            borderBottom: `1px solid ${theme.palette.grey[100]}`,
        } },
        React.createElement(PeekTabs, { value: activeTabIndex, onChange: onTabChange }, tabs.map((tab) => (React.createElement(PeekTab, { key: tab.id, label: React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 0.8 },
                React.createElement("span", null, tab.label),
                React.createElement(PeekBox, { component: "span", sx: {
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: theme.spacing(2),
                        height: theme.spacing(2),
                        borderRadius: theme.spacing(1),
                        backgroundColor: tab.id === activeTabId ? theme.palette.primary.main : theme.palette.grey[300],
                        color: tab.id === activeTabId ? theme.palette.common.white : theme.palette.text.secondary,
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        px: theme.spacing(0.5),
                    } }, tab.count)) })))),
        React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 1 },
            React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 0.5, p: 1, sx: {
                    borderRadius: theme.spacing(0.5),
                    bgcolor: isLimitReached ? theme.palette.error.light : theme.palette.teal[100],
                } },
                React.createElement(PeekTypography, { variant: "h5" }, intl.formatMessage(messages.customSubtopicsLabel)),
                React.createElement(PeekTypography, { variant: "h5", fontWeight: "fontWeightMedium", color: isLimitReached ? "error" : "inherit" },
                    customSubtopicsCount,
                    "/",
                    maxCustomSubtopics),
                React.createElement(PeekTooltip, { title: React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(messages.customSubtopicsInfoTooltip, { max: maxCustomSubtopics })) },
                    React.createElement(PeekTypography, { lineHeight: 0 },
                        React.createElement(InfoIcon, null)))))));
};
